import type {TuiCountryIsoCode, TuiLanguage, TuiLanguageCommerce, TuiLanguageCore, TuiLanguageEditor, TuiLanguageKit, TuiLanguageLayout, TuiLanguageTable} from '@taiga-ui/i18n/types';

export const TUI_ICELANDIC_LANGUAGE_ADDON_COMMERCE: TuiLanguageCommerce = {
    cardNumber: ['Númer', 'Kortanúmer'],
    cardExpiry: ['Rennur út', 'Útgáfudagur'],
};

export const TUI_ICELANDIC_LANGUAGE_LAYOUT: TuiLanguageLayout = {
    inputSearch: {
        popular: 'Vinsælt',
        history: 'Nýlegt',
        placeholder: 'Leita',
        hotkey: 'til að leita',
        all: 'Allt',
        empty: 'Engar niðurstöður',
    },
};

export const TUI_ICELANDIC_LANGUAGE_KIT: TuiLanguageKit = {
    cancel: 'Hætta við',
    done: 'Lokið',
    more: 'Meira',
    otherDate: 'Annað dagsetning...',
    showAll: 'Sýna allt',
    hide: 'Fela',
    mobileCalendarTexts: [
        'Veldu dag',
        'Veldu tímabil',
        'Veldu daga',
    ],
    range: ['Frá', 'Til'],
    countTexts: ['Meira', 'Minna'],
    time: {
        'HH:MM': 'HH:MM',
        'HH:MM AA': 'HH:MM AA',
        'HH:MM:SS': 'HH:MM:SS',
        'HH:MM:SS AA': 'HH:MM:SS AA',
        'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
        'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA',
    },
    dateTexts: {
        DMY: 'dagur.mánuður.ár',
        MDY: 'mánuður.dagur.ár',
        YMD: 'ár.mánuður.dagur',
    },
    digitalInformationUnits: ['Bæti', 'Kilóbæti', 'Megabæti'],
    passwordTexts: ['Sýna lykilorð', 'Fela lykilorð'],
    copyTexts: ['Afrita', 'Afritað'],
    shortCalendarMonths: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Maí',
        'Jún',
        'Júl',
        'Ágú',
        'Sep',
        'Okt',
        'Nóv',
        'Des',
    ],
    pagination: ['Fyrri síða', 'Næsta síða'],
    fileTexts: {
        loadingError: 'Villa við hleðslu',
        preview: 'Forskoðun',
        remove: 'Fjarlægja',
    },
    inputFileTexts: {
        defaultLabelSingle: 'eða draga hér',
        defaultLabelMultiple: 'eða draga hér',
        defaultLinkSingle: 'Veldu skrá',
        defaultLinkMultiple: 'Veldu skrár',
        maxSizeRejectionReason: 'Skrá of stór',
        formatRejectionReason: 'Ógilt skráarsnið',
        drop: 'Slepptu skrá hér',
        dropMultiple: 'Slepptu skrám hér',
    },
    multiSelectTexts: {
        all: 'Velja allt',
        none: 'Velja ekkert',
    },
    confirm: {
        yes: 'Já',
        no: 'Nei',
    },
    previewTexts: {
        rotate: 'Snúa',
    },
    zoomTexts: {
        zoomOut: 'Afturkalla aðdrátt',
        zoomIn: 'Aðdráttur',
        reset: 'Endurstilla',
    },
    phoneSearch: 'Leita land eða kóða',
};

export const TUI_ICELANDIC_LANGUAGE_ADDON_EDITOR: TuiLanguageEditor = {
    colorSelectorModeNames: ['Einfalt litur', 'Litabreyta'],
    toolbarTools: {
        undo: 'Afturkalla',
        redo: 'Endurtaka',
        font: 'Letur',
        fontStyle: 'Leturgerð',
        fontSize: 'Leturstærð',
        bold: 'Feitletrað',
        italic: 'Skáletrað',
        underline: 'Undirstrikað',
        strikeThrough: 'Yfirstrikað',
        justify: 'Jafna',
        justifyLeft: 'Jafna vinstri',
        justifyCenter: 'Jafna miðju',
        justifyRight: 'Jafna hægri',
        justifyFull: 'Jafna fullkomlega',
        list: 'Listi',
        indent: 'Auka inndrátt',
        outdent: 'Minnka inndrátt',
        unorderedList: 'Ónúmeraður listi',
        orderedList: 'Númeraður listi',
        quote: 'Tilvitnun',
        foreColor: 'Textalitur',
        backColor: 'Bakgrunnslitur',
        hiliteColor: 'Áherslulitur',
        clear: 'Hreinsa',
        link: 'Hlekkur',
        attach: 'Hengja við skrá',
        tex: 'Setja inn TeX',
        code: 'Kóði',
        image: 'Setja inn mynd',
        insertHorizontalRule: 'Setja inn lárétta línu',
        superscript: 'Uppskrift',
        subscript: 'Niðurskrift',
        insertTable: 'Setja inn töflu',
        insertGroup: 'Setja inn hóp',
        hiliteGroup: 'Áhersla hóps',
        removeGroup: 'Fjarlægja hóp',
        insertAnchor: 'Setja inn akkeri',
        mergeCells: 'Sameina reiti',
        splitCells: 'Skipta reitum',
        rowsColumnsManaging: 'Stjórna línum og dálkum',
        cellColor: 'Reitlitur',
        setDetails: 'Setja upplýsingar',
        removeDetails: "Fjarlægja upplýsingar",
    },
    editorEditLink: {
        urlExample: 'dæmi.com',
        anchorExample: 'akkeri',
    },
    editorTableCommands: [
        ['Setja inn dálk fyrir', 'Setja inn dálk eftir'],
        ['Setja inn línu fyrir', 'Setja inn línu eftir'],
        ['Fjarlægja dálk', 'Fjarlægja línu'],
    ],
    editorCodeOptions: ['Kóði í texta', 'Kóðablokk'],
    editorFontOptions: {
        small: 'Lítill',
        large: 'Stór',
        normal: 'Venjulegur',
        title: 'Titill',
        subtitle: 'Undirtitill',
    },
};

export const TUI_ICELANDIC_LANGUAGE_ADDON_TABLE: TuiLanguageTable = {
    showHideText: 'Sýna/Fela',
    paginationTexts: {
        pages: 'Síður',
        linesPerPage: 'Línur á síðu',
        of: 'af',
    },
};

export const TUI_ICELANDIC_LANGUAGE_CORE: TuiLanguageCore = {
    months: [
        'Janúar',
        'Febrúar',
        'Mars',
        'Apríl',
        'Maí',
        'Júní',
        'Júlí',
        'Ágúst',
        'September',
        'Október',
        'Nóvember',
        'Desember',
    ],
    close: 'Loka',
    clear: 'Hreinsa',
    nothingFoundMessage: 'Engar niðurstöður',
    defaultErrorMessage: 'Ógild gildi',
    spinTexts: ['Fyrri', 'Næsti'],
    shortWeekDays: ['Mán', 'Þri', 'Mið', 'Fim', 'Fös', 'Lau', 'Sun'],
    countries: {} as Record<TuiCountryIsoCode, string>,
};

export const TUI_ICELANDIC_LANGUAGE: TuiLanguage = {
    name: 'icelandic',
    ...TUI_ICELANDIC_LANGUAGE_CORE,
    ...TUI_ICELANDIC_LANGUAGE_KIT,
    ...TUI_ICELANDIC_LANGUAGE_ADDON_TABLE,
    ...TUI_ICELANDIC_LANGUAGE_ADDON_COMMERCE,
    ...TUI_ICELANDIC_LANGUAGE_ADDON_EDITOR,
    ...TUI_ICELANDIC_LANGUAGE_LAYOUT,
};